import { PAGE_NAMES, BULK_ACTIONS_RESOURCES, ACTION, ACL_RESOURCES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermissionV2 } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Execute Bulk Refund',
				id: 'executeBulkRefund',
				isEnabled: (rowData: any) => {
					const { state, refundedAt, refundedBy } = rowData;
					if ((refundedAt || refundedBy) && (state === 'PROCESSING' || state === 'SUCCESS')) {
						return false;
					}

					return hasPermissionV2({
						configPageName: PAGE_NAMES.bulkActions,
						configResourceName: BULK_ACTIONS_RESOURCES.bulkRefund,
						configActionName: ACTION.bulkRefundFromCsv
					});
				}
			},
			{
				name: 'Execute Bulk Refund V2',
				id: 'executeBulkRefundV2',
				isEnabled: (rowData: any) => {
					const { state, refundedAt, refundedBy, isBulkRefundV2 } = rowData;
					if ((refundedAt || refundedBy) && (state === 'PROCESSING' || state === 'SUCCESS')) {
						return false;
					}

					if (!isBulkRefundV2) {
						return false;
					}
					return hasPermissionV2({
						configPageName: PAGE_NAMES.bulkActions,
						configResourceName: ACL_RESOURCES.bulkRefundV2,
						configActionName: ACTION.bulkRefundFromCsvV2
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermissionV2({
					configPageName: PAGE_NAMES.bulkActions,
					configResourceName: BULK_ACTIONS_RESOURCES.bulkRefund,
					configActionName: ACTION.uploadBulkRefundCsv
				});
			}
		}
	};
};

export default {
	makeActionList
};
